
import React from 'react'
import useMode  from './hooks/useMode'
import { GlobalStyle } from "./assets/GlobalStyle"
import { theme, browntheme, greentheme } from "./assets/theme.js"
import { Routes, Route } from 'react-router';
import styled, { ThemeProvider } from 'styled-components'

// Component imports
import Header from './components/Header/Header';
import Home from './components/Home/Home'
import Catalogues from './components/Catalogues/Catalogues'
import HDSpa from './components/HDSpa/HDSpa'
import About from "./components/About/About";

// Image imports
import logo from "./images/logo.svg";
import iconHB from "./images/icon-hamburger.svg";
import iconClose from "./images/icon-close.svg";
import catalogueBg from './images/catalogue-bg.jpg'
import weatherImg from './images/weather-img.jpg'
import textureImg from './images/texture-img.jpg'
import themeImg from "./images/theme-img.jpg";
import exploreImg from "./images/explore-img.jpg";
import HdspaBg from "./images/hdspa-bg.jpg";



const AppWrapper = styled.section`
  display: grid;
  grid-template-rows: minmax(min-content, 10vh) 1fr;
  min-height: 100vh;
`;

const App = () => {
    const { theme: providedTheme, toggleTheme } = useMode();
    const catalogueImages = [weatherImg, textureImg, themeImg, exploreImg]
      const allLinks = [
        {
          id: 0,
          linkName: "home",
          linkPath: "/",
        },
        {
          id: 1,
          linkName: "catalogues",
          linkPath: "/catalogues",
        },
        {
          id: 2,
          linkName: "HDSpa",
          linkPath: "/HDSpa",
        },
        {
          id: 3,
          linkName: "Book session",
          linkPath: "/#",
        },
        {
          id: 4,
          linkName: "Store",
          linkPath: "/#",
        },
        {
          id: 5,
          linkName: "Contact us",
          linkPath: "/#",
        },
        {
          id: 6,
          linkName: "about us",
          linkPath: "/about",
        },
        {
          id: 7,
          linkName: "Pricing Policy",
          linkPath: "/#",
        },
      ];
    let currentTheme 
    if(providedTheme === 'default'){
      currentTheme = theme
    } else if(providedTheme === 'brown'){
      currentTheme = browntheme
    
    } else if(providedTheme === 'green'){
      currentTheme = greentheme
    }
  return (
    <ThemeProvider theme={currentTheme}>
      <GlobalStyle />
      <AppWrapper>
        <Header
          toggleTheme={toggleTheme}
          theme={theme}
          providedTheme={providedTheme}
          logo={logo}
          iconHB={iconHB}
          iconClose={iconClose}
          allLinks={allLinks}
        />
        <Routes>
          <Route
            path="/"
            element={
              <Home
                links={allLinks.filter((link, idx, links) => {
                  return idx > links.length / 2 && link;
                })}
              />
            }
          />
          <Route
            path="/Catalogues"
            element={
              <Catalogues
                bgImage={catalogueBg}
                catalogueImages={catalogueImages}
              />
            }
          />
          <Route path="/HDSpa" element={<HDSpa bgImage={HdspaBg} />} />
          <Route path="/about" element={<About />} />
          <Route
            element={
              <Home
                links={allLinks.filter((link, idx, links) => {
                  return idx > links.length / 2 && link;
                })}
              />
            }
          />
        </Routes>
      </AppWrapper>
    </ThemeProvider>
  );
}



export default App;
